import { controlador, urlBase,urlPhp8 } from "constants/urls";

export const FAQS = {
  urls: {
    faqSeccion: '/faqs',
  },
  endpoints: {
    faqs: `${urlPhp8}${controlador}v2/faqs/get-faqs`,
  }

};